import React from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from "reactstrap";
import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";

const LocationModal = ({ isOpen, onClose, selectedItem }) => {
  const koordinat = selectedItem && (selectedItem.titikKoordinatRumah || selectedItem.manualTitikKoordinatRumah);

  let latitude = null;
  let longitude = null;
  if (koordinat) {
    const parts = koordinat.split(',').map((coord) => parseFloat(coord.trim()));
    latitude = parts[0];
    longitude = parts[1];
  }

  const isValid = typeof latitude === 'number' && !Number.isNaN(latitude) && typeof longitude === 'number' && !Number.isNaN(longitude);

  return (
    <Modal isOpen={isOpen} toggle={onClose} style={{ paddingTop: "40px" }}>
      <ModalHeader toggle={onClose}>Detail Lokasi</ModalHeader>
      <ModalBody>
        {selectedItem && koordinat ? (
          isValid ? (
            <>
              <div className="mb-3">
                <p className="mb-1"><strong>Kecamatan:</strong> {selectedItem.kecamatan}</p>
                <p className="mb-1"><strong>Desa/Kelurahan:</strong> {selectedItem.desaKelurahan}</p>
                <p className="mb-3"><strong>Koordinat:</strong> {koordinat}</p>
              </div>
              <div style={{ height: '400px', width: '100%', border: '1px solid #ddd', borderRadius: '4px', overflow: 'hidden' }}>
                <MapContainer center={[latitude, longitude]} zoom={15} style={{ height: '100%', width: '100%' }}>
                  <TileLayer url="https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}" attribution='&copy; <a href="https://www.esri.com/">Esri</a>' />
                  <Marker position={[latitude, longitude]}>
                    <Popup>Koordinat: {latitude}, {longitude}</Popup>
                  </Marker>
                </MapContainer>
              </div>
            </>
          ) : (
            <p>Koordinat tidak valid.</p>
          )
        ) : (
          <p>Koordinat tidak tersedia</p>
        )}
      </ModalBody>
      <ModalFooter>
        <Button color="secondary" onClick={onClose}>Tutup</Button>
      </ModalFooter>
    </Modal>
  );
};

export default LocationModal;


